export const COMMENT_ATTACHMENT_ADDED = 'COMMENT_ATTACHMENT_ADDED';

export const setCommentAttachmentAddedSessionStorage = () => {
    sessionStorage.setItem(COMMENT_ATTACHMENT_ADDED, '1');
}
